export const tiposVenta = [
  { id: true, label: 'Crédito' },
  { id: false, label: 'Contado' },
];

export default tiposVenta;